module.exports = __webpack_public_path__ + "static/img/legend_xg_vertical.5ce2787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_vertical.png
// module id = AzRh
// module chunks = 94